import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { toast } from "sonner";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import BirthDetailsModal from "./BirthDetailsModal";

// Routes where we should NOT force onboarding (astrologer-side, auth flows,
// or admin tools that don't need a customer kundali to function).
const SKIP_ROUTES = [
  "/astrologer/login",
  "/astrologer/register",
  "/astrologer/dashboard",
  "/admin",
];

/**
 * Global onboarding gate. After a customer signs in, force them to fill birth
 * details ONCE. Once saved, kundali is computed and every astrologer (AI or human)
 * fetches it automatically — no one will ever ask the seeker for these again.
 */
export default function OnboardingGate() {
  const { user, loading, checkAuth } = useAuth();
  const location = useLocation();
  const [submitting, setSubmitting] = useState(false);

  if (loading || !user) return null;
  // Only customers go through this gate
  if (user.role && user.role !== "customer") return null;
  if (user.birth_details) return null;
  if (SKIP_ROUTES.some((r) => location.pathname.startsWith(r))) return null;

  const handleSubmit = async ({ date, time, place, timezone }) => {
    if (submitting) return;
    setSubmitting(true);
    try {
      await api.post("/customer/birth-details", { date, time, place, timezone });
      await checkAuth();
      toast.success("Birth details saved — your kundali is ready ✨");
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.detail || "Could not save your birth details. Please try again.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <BirthDetailsModal
      required
      onSubmit={handleSubmit}
      onSkip={() => {}}
    />
  );
}
